import { graphql } from "@/lib/gql/__generated__/gql";

export const PLAIN_WIDGET_FOR_DESIGN_PLAIN_QUERY = graphql(/* GraphQL */ `
	query PlainWidgetForDesignPlain($hotelID: ID!) {
		plainWidget(hotelID: $hotelID) {
			id
			hotelID
			widgetItems {
				widgetID
				contentID
				widgetType
				title
			}
		}
	}
`);
